export enum GeographyTypeEnum {
    country = 'country',
    voivodeship = 'voivodeship',
    region = 'region',
    city = 'city',
    accommodation = 'accommodation',
}
